import React from "react";
import image1 from "./about us images/blends-hero-800x800.jpg";
import image2 from "./about us images/diffuserv2-hero-800x800.jpg";
import image3 from "./about us images/singles-hero-800x800.jpg";
function Aboutus() {
  return (
    <div className="mt-[100px] phone:mt-[74px]">
      <div className="slm">
        <div className="bg-primary-100 relative flex justify-center items-center font-font1 text-[50px] w-full h-[250px]">
          <img
            className="absolute object-cover w-full h-[250px]"
            src="https://images.unsplash.com/photo-1428908728789-d2de25dbd4e2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
            alt="sky"
          />
          <h1 className="z-50 text-gray-900 main-titles text-center">
            Our Miracle Story
          </h1>
        </div>
      </div>
      <div className="flex items-center tablet:flex-col relative w-full gap-x-8 my-24">
        <div className="w-full 2xl:w-1/2 relative">
          <img
            className="object-cover z-10 rounded-md w-full h-[300px] lg:h-[400px]"
            src={image1}
            alt="image1"
          />
          <div className="bg-primary-100 -z-10 tablet:hidden rounded-md absolute h-[300px] lg:h-[400px] w-full top-[54%] left-[47%] -translate-x-1/2 -translate-y-1/2"></div>
        </div>
        <div className="w-full 2xl:w-1/2 space-y-6 tablet:text-center tablet:justify-center tablet:mt-10">
          <h1 className="main-mini-titles text-primary-100">
            Miracle Signature Blends<sup>®</sup>
          </h1>

          <p>
            Miracle Signature Blends <sup> ® </sup>
            has been meticulously and scientifically formulated by our
            experienced oil specialists to ensure only the highest quality. Each
            blend consists of a careful combination of different ingredients
            designed to address many of life’s common challenges. Multiple oils
            work together to cultivate specific sensory experiences, as well as
            helping the mind and body attain harmony and equilibrium. Feeling
            sluggish? Jump start each morning with our Energy Blend.
          </p>
          <p>
            Need a little push to tackle demanding tasks? A drop of Motivation
            will do the trick! Is your mind always wandering? Conquer boredom
            and distraction with our Focus Signature Blend. Whatever life may
            throw at you, you can rest assured there's a Signature Blend that
            can accompany you through even the most trying, tedious tasks.
          </p>
        </div>
      </div>
      <div className="flex items-center  tablet:flex-col-reverse relative w-full gap-x-8 my-24">
        <div className="w-full 2xl:w-1/2 space-y-6  tablet:text-center tablet:justify-center tablet:mt-10">
          <h1 className="main-mini-titles text-primary-100">
            Miracle Single Oils<sup>®</sup>
          </h1>

          <p>
            {" "}
            Miracle Single Oils <sup> ® </sup>
            Our Miracle Single Oils can only be described as pure and luxurious,
            something you instantly discover as soon as you unscrew the bottle
            cap. These fragrant, versatile single oils contain over a hundred
            natural chemical constituents, each with their own unique
            properties.
          </p>
          <p>
            {" "}
            Whether you simply wish to enjoy the aromatic scents of lavender,
            lemon, or peppermint, want to incorporate them into delicious
            recipes, or are interested in the deeper benefits each oil has to
            offer, there's something for everyone in our Single Oils collection.
          </p>
        </div>
        <div className="w-full 2xl:w-1/2 relative">
          <img
            className="object-cover z-10 rounded-md w-full h-[300px] lg:h-[400px]"
            src={image3}
            alt="image3"
          />
          <div className="bg-primary-100 -z-10 tablet:hidden rounded-md absolute h-[300px] lg:h-[400px] w-full top-[54%] left-[54%] -translate-x-1/2 -translate-y-1/2"></div>
        </div>
      </div>
      <div className="flex items-center tablet:flex-col relative w-full gap-x-8 my-24">
        <div className="w-full 2xl:w-1/2 relative">
          <img
            className="object-cover z-10 rounded-md w-full h-[300px] lg:h-[400px]"
            src={image2}
            alt="image2"
          />
          <div className="bg-primary-100 -z-10 tablet:hidden rounded-md absolute h-[300px] lg:h-[400px] w-full top-[54%] left-[47%] -translate-x-1/2 -translate-y-1/2"></div>
        </div>
        <div className="w-full 2xl:w-1/2 space-y-6 tablet:text-center tablet:justify-center tablet:mt-10">
          <h1 className="main-mini-titles text-primary-100">
            Miracle Accessories<sup>®</sup>
          </h1>

          <p>
            {" "}
            Miracle Signature Blends <sup> ® </sup>
            One of the ways to enjoy the many benefits of essential oils is by
            pairing them with our exclusive set of specially crafted
            accessories. Our beautifully designed Ultrasonic Diffuser blends
            seamlessly with your home or office decor while also delivering the
            unique, aromatic experience of essential oils. The Miracle Spray
            Bottle offers a convenient way to use essential oils in your
            household. Lastly, the Miracle Roller Bottle is a must-have
            accessory for an on-the-go essential oil experience.
          </p>
          <p>
            {" "}
            Need a little push to tackle demanding tasks? A drop of Motivation
            will do the trick! Is your mind always wandering? Conquer boredom
            and distraction with our Focus Signature Blend. Whatever life may
            throw at you, you can rest assured there’s a Signature Blend that
            can accompany you through even the most trying, tedious tasks.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Aboutus;
